module.exports = __webpack_public_path__ + "img/Restaurant7.fd97de6d.png";